import React from "react";
import { ClickEventType, DefaultFacility } from "../../../types";
import { Box, Stack } from "@mui/material";
import { ColorIcon } from "../../common/Icons";
import { ColorSystemProps } from "../../../constants";
import { colors } from "../../../styles";
import { FullWidthButton } from "../../common/Buttons/FullWidthButton";

export function CTypeFacilityMainHead({
  title,
  sidoName,
  sigunguName,
  defaultFacility,
  mainColor,
  isRegion,
  event,
}: {
  title: string;
  sidoName?: string;
  sigunguName?: string;
  defaultFacility: DefaultFacility;
  mainColor: ColorSystemProps;
  isRegion?: boolean;
  event?: ClickEventType;
}) {
  return (
    <Stack position="relative" padding="20px">
      <h1 className="subtitle_21_b ">{title}</h1>

      <Stack gap="6px" marginTop="13px">
        <Stack flexDirection="row" gap="6px">
          <ColorIcon
            name="icon-location-fill"
            size={20}
            color={colors.gray300}
          />
          <Box>
            {isRegion
              ? sidoName +
                (sigunguName ? " " + sigunguName : "") +
                "지역 장례식장 추천 및 비용 안내"
              : defaultFacility.address}
          </Box>
        </Stack>
        <Stack flexDirection="row" gap="6px">
          <ColorIcon name="timer" size={20} color={colors.gray300} />
          <Box>00:00 ~ 24:00</Box>
        </Stack>
      </Stack>

      <Box
        width="100%"
        height="1px"
        style={{ background: colors.gray300 }}
        margin="9px 0"
      />

      <FullWidthButton
        backgroundColor={mainColor.c400}
        text="장지 견적 문의하기"
        href="tel:1666-9784"
        event={event}
      />
    </Stack>
  );
}
